import * as _ from 'lodash';
import { AccountServiceBase } from "../../config";
import { checkResponseErrors, makeRequestInit } from '../fetchHelper';
import { UserData } from './UserData';
import type { Authentication } from "../auth/Authentication";

export class UsersEndpoints {
    private _auth: Authentication;
    
    constructor(auth: Authentication) {
        this._auth = auth;
    }

    getUsers() {
        return this._auth
            .fetch(AccountServiceBase + '/users', makeRequestInit('GET'))
            .then(checkResponseErrors)
            .then(rsp => rsp.json())
            .then(data => _.map(data, x => new UserData(x)));
    }
}
